import { useSearchParams } from 'react-router-dom';

import { formatDate } from '@/utils';

import { DateRange, parseRange, presetRange } from './date-ranges';

const FROM_INCLUSIVE = 'fromInclusive';
const TO_INCLUSIVE = 'toInclusive';

/** Query params holding the reporting date range, e.g. to carry the range across reporting tabs. */
export const REPORTING_DATE_RANGE_SEARCH_PARAMS = [FROM_INCLUSIVE, TO_INCLUSIVE] as const;

export const useReportingDateRange = (): {
    dateRange: DateRange;
    setDateRange: (range: DateRange) => void;
} => {
    const [params, setParams] = useSearchParams();
    // Year to date when the URL carries no range, mirroring client-portal's default. An
    // inception-to-date default (via reporting ReportInfo.minTradeDate) is a future enhancement.
    const range = parseRange(params.get(FROM_INCLUSIVE), params.get(TO_INCLUSIVE)) ?? presetRange('YTD');

    const setRange = (next: DateRange) => {
        const updated = new URLSearchParams(params);
        updated.set(FROM_INCLUSIVE, formatDate(next.fromInclusive, 'SERVER'));
        updated.set(TO_INCLUSIVE, formatDate(next.toInclusive, 'SERVER'));
        setParams(updated, { replace: true });
    };

    return { dateRange: range, setDateRange: setRange };
};
